import { render, staticRenderFns } from "./singleComment.vue?vue&type=template&id=170fa21e&scoped=true"
import script from "./singleComment.vue?vue&type=script&lang=js"
export * from "./singleComment.vue?vue&type=script&lang=js"
import style0 from "./singleComment.vue?vue&type=style&index=0&id=170fa21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170fa21e",
  null
  
)

export default component.exports